<template>
    <transition name="fade">
        <div
            tabindex="-1"
            :class="[
                size,
                `
                    absolute
                    top-0
                    right-0
                    left-0
                    z-50
                    flex
                    flex-col
                    items-center
                    w-full
                    min-h-screen
                `
            ]"
        >
            <button
                @click="close"
                class="
                    fixed
                    top-0
                    left-0
                    w-full
                    h-full
                    bg-black
                    bg-opacity-40
                "
            />

            <button
                v-if="closable"
                @click="close"
                aria-label="Sluiten"
                class="
                    absolute
                    top-2
                    right-2
                    z-20
                    flex
                    items-center
                    justify-center
                    w-8
                    h-8
                    rounded-full
                    text-2xl
                    border
                    border-solid
                    border-primary
                    bg-white
                    hover:text-white
                    hover:bg-primary
                    custom-modal-close
                "
            >
                <ui-icon icon="close" />
            </button>

            <div
                class="
                    relative
                    z-10
                    flex
                    flex-col
                    w-full
                    px-4
                    lg:px-0
                    lg:my-8
                    lg:mx-auto
                    overflow-y-auto
                    rounded
                    custom-modal-box
                "
            >
                <div v-if="$slots.header || title">
                    <slot name="pre-header" />

                    <h2
                        v-if="title"
                    >
                        {{ title }}
                    </h2>

                    <slot name="header" />
                </div>

                <div
                    class="
                        p-4
                        lg:p-8
                        bg-white
                        custom-modal-box-content
                    "
                >
                    <slot />
                </div>

                <div
                    v-if="$slots.footer"
                    class="bg-blue-50"
                >
                    <slot name="footer" />
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import { mapMutations } from 'vuex';

export default {
    name: 'UiModal',
    data() {
        return {
            mainContent: document.querySelector('.app-content'),
        };
    },
    props: {
        title: {
            type: String,
            default: null,
        },
        closable: {
            type: Boolean,
            default: true,
        },
        size: {
            type: String,
            default: 'medium',
        },
    },
    async mounted() {
        await this.$nextTick();

        this.mainContent.style.top = -window.pageYOffset + 'px';
        document.body.classList.add('custom-modal-open');

        document.addEventListener('keyup', (e) => {
            if (e.key === 'Escape') this.close();
        });
    },
    destroyed() {
        const scrollOffset = Math.abs(parseFloat(this.mainContent.style.top));

        document.body.classList.remove('custom-modal-open');
        document.removeEventListener('keyup', this.close);

        this.mainContent.style.removeProperty('top');

        window.scrollTo(0, scrollOffset, { duration: 0 });
    },
    methods: {
        ...mapMutations('modal', [
            'setModal',
        ]),

        close() {
            if (!this.closable) return;

            this.setModal(null);
            this.$emit('close');
        },
    },
};
</script>

<style lang="scss">
    $modal-width-lg: 864px;

    .custom-modal {
        &-open .app-content {
            position: fixed;
            display: flex;
            width: 100%;
        }

        &-box {
            max-height: calc(100vh - 32px);
            box-shadow: 1px 1px 2px rgba(#000, 0.05);

            @screen lg {
                max-width: $modal-width-lg;
                max-height: calc(100vh - 64px);
            }

            .modal-small & {
                width: 480px;
            }
        }

        &-close {
            @screen lg {
                right: calc((100vw - #{$modal-width-lg}) / 2 - 16px);
            }
        }
    }
</style>
